import { Base } from "ui/Scripts/source/framework/base";
import { IdColorTitle, IIdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { Translations } from "ui/Scripts/source/models/translations";

export const TaskStateIdFilterAll = Base.emptyGuid;
export const TaskStateIdFilterActive = "00000000-0000-0000-0000-000000000001";
export const TaskStateIdFilterArchived = "00000000-0000-0000-0000-000000000002";

export interface ITaskPageFilterLists {
    units: IIdTitleNode[];
    states: IIdColorTitle[];
    priorities: IIdTitle[];
    taskTypes: ITaskEditTypeItem[];
    handlers: IIdTitle[];
    personsInCharge: IIdTitle[];
}

export interface ITaskPageFilterState {
    selectedUnitIds: string[];
    selectedStateIds: string[];
    selectedPriorityIds: string[];
    selectedTaskTypeIds: string[];
    selectedHandlerUserCodes: string[];
    selectedPersonInChargeUserCodes: string[];
    selectedTaskTypeHeaderFields: string;
    selectedTaskTypeFields: string;
}

export interface ITaskGeneralFilter {
    unitIds: string[];
    stateIds: string[];
    priorityIds: string[];
    taskTypeIds: string[];
    handlerUserCodes: string[];
    personInChargeUserCodes: string[];
    taskTypeHeaderFields: string;
    taskTypeFields: string;
}

export interface ITaskGeneralFilterChange extends ITaskGeneralFilter {
    notChanged: boolean;
}

export const getTaskGeneralFilterFromFilterState = (state: ITaskPageFilterState): ITaskGeneralFilter => {
    return {
        unitIds: state.selectedUnitIds ? state.selectedUnitIds.filter(i => i !== Base.emptyGuid) : [],
        stateIds: state.selectedStateIds ? state.selectedStateIds.filter(i => i !== TaskStateIdFilterAll) : [],
        priorityIds: state.selectedPriorityIds ? state.selectedPriorityIds.filter(i => i !== Base.emptyGuid) : [],
        taskTypeIds: state.selectedTaskTypeIds ? state.selectedTaskTypeIds.filter(i => i !== Base.emptyGuid) : [],
        handlerUserCodes: state.selectedHandlerUserCodes ? state.selectedHandlerUserCodes.filter(i => !!i) : [],
        personInChargeUserCodes: state.selectedPersonInChargeUserCodes ? state.selectedPersonInChargeUserCodes.filter(i => !!i) : [],
        taskTypeHeaderFields: state.selectedTaskTypeHeaderFields ? state.selectedTaskTypeHeaderFields : null,
        taskTypeFields: state.selectedTaskTypeFields ? state.selectedTaskTypeFields : null
    };
};

export const getFilterStateFromTaskGeneralFilter = (generalFilter: any): ITaskPageFilterState => {
    return {
        selectedUnitIds: generalFilter && generalFilter.unitIds && generalFilter.unitIds.length > 0 ? generalFilter.unitIds : [Base.emptyGuid],
        selectedStateIds: generalFilter && generalFilter.stateIds && generalFilter.stateIds.length > 0 ? generalFilter.stateIds : [TaskStateIdFilterAll],
        selectedPriorityIds: generalFilter && generalFilter.priorityIds && generalFilter.priorityIds.length > 0 ? generalFilter.priorityIds : [Base.emptyGuid],
        selectedTaskTypeIds: generalFilter && generalFilter.taskTypeIds && generalFilter.taskTypeIds.length > 0 ? generalFilter.taskTypeIds : [Base.emptyGuid],
        selectedHandlerUserCodes: generalFilter && generalFilter.handlerUserCodes && generalFilter.handlerUserCodes.length > 0 ? generalFilter.handlerUserCodes : [""],
        selectedPersonInChargeUserCodes: generalFilter && generalFilter.personInChargeUserCodes && generalFilter.personInChargeUserCodes.length > 0 ? generalFilter.personInChargeUserCodes : [""],
        selectedTaskTypeHeaderFields: generalFilter && generalFilter.taskTypeHeaderFields ? generalFilter.taskTypeHeaderFields : "",
        selectedTaskTypeFields: generalFilter && generalFilter.taskTypeFields ? generalFilter.taskTypeFields : "",
    };
};

export const getTaskGeneralFilterNotChanged = (prevFilter: ITaskGeneralFilter, filter: ITaskGeneralFilter): boolean => {
    return Base.equalStrArrays(prevFilter.unitIds, filter.unitIds) &&
        Base.equalStrArrays(prevFilter.stateIds, filter.stateIds) &&
        Base.equalStrArrays(prevFilter.priorityIds, filter.priorityIds) &&
        Base.equalStrArrays(prevFilter.taskTypeIds, filter.taskTypeIds) &&
        Base.equalStrArrays(prevFilter.handlerUserCodes, filter.handlerUserCodes) &&
        Base.equalStrArrays(prevFilter.personInChargeUserCodes, filter.personInChargeUserCodes) &&
        (prevFilter.taskTypeHeaderFields ?? "") === (filter.taskTypeHeaderFields ?? "") &&
        (prevFilter.taskTypeFields ?? "") === (filter.taskTypeFields ?? "");
};

export const getTaskGeneralFilterChange = (prevProps: ITaskPageFilterState, props: ITaskPageFilterState): ITaskGeneralFilterChange => {
    const prevFilter = getTaskGeneralFilterFromFilterState(prevProps);
    const filter = getTaskGeneralFilterFromFilterState(props);
    return {
        ...filter,
        notChanged: getTaskGeneralFilterNotChanged(prevFilter, filter)
    };
};

export const taskStateDividerId = "00000000-0000-0000-0000-000000009999";

export const getTaskStates = (states: IIdColorTitle[]): IIdColorTitle[] => {
    const result: IIdColorTitle[] = [];
    let archivedAdded = false;
    result.push(IdColorTitle.createIdColorTitle(TaskStateIdFilterActive, "", "'" + Translations.ActivePlural + "'"));
    result.push(IdColorTitle.createIdColorTitle(TaskStateIdFilterAll, "", "'" + Translations.All + "'"));
    for (const taskState of states) {
        if (taskState.id === Base.emptyGuid) {
            if (!archivedAdded) {
                result.push(IdColorTitle.createIdColorTitle(TaskStateIdFilterArchived, "", Translations.Archived));
                archivedAdded = true;
            }
            result.push(IdColorTitle.createIdColorTitle(taskStateDividerId, "", taskState.title));
        } else {
            result.push(taskState);
        }
    }
    if (!archivedAdded) {
        result.push(IdColorTitle.createIdColorTitle(TaskStateIdFilterArchived, "", Translations.Archived));
    }
    return result;
    // return result.concat(states);
};